import React from 'react';
import Header from '../components/layout/header';
import './index.css'
import Sec1 from '../sections/sec1';
import Sec2 from '../sections/sec2';
import Sec3 from '../sections/sec3';
import Sec4 from '../sections/sec4';
import Sec5 from '../sections/sec5';
import Sec6 from '../sections/sec6';
import Sec7 from '../sections/sec7';
import Footer from '../components/layout/footer';
import Preloader from '../components/layout/preloader';
import { useState } from 'react';

const Home = () => {
  const [loading, setLoading] = useState(true);

  return (
<>
  {loading && (
    <Preloader onFinish={() => setLoading(false)} />
  )}

  {!loading && (
    <>
      <Header />
      <main>
        <Sec1 />
        <Sec2 />
        <Sec3 />
        <Sec4 />
        <Sec5 />
        <Sec6 />
        <Sec7 />
      </main>
      <Footer />
    </>
  )}
</>
  );
};
export default Home;